import { createReducer, on } from "@ngrx/store";
import { GenericStoreApiData } from "src/components/shared-components/interfaces/generic-store-api-data";
import {
  addressTreeLoadErrorAction,
  addressTreeLoadInitStartAction,
  addressTreeLoadSuccessAction,
  addressTreeUnsetKeyStorage,
} from "../actions/address.action";

/**
 * Initial state of areas store
 */
const initialState: GenericStoreApiData = {
  loaded: false,
  errorGeneric: false,
  errorNotYetImplemented: false,
  isOldDataInUse: false,
  data: null,
};

/**
 * Reducer for areas
 */
export const AddressReducer = createReducer(
  initialState,
  on(addressTreeUnsetKeyStorage, (areaObject: GenericStoreApiData, action) => {
    return initialState;
  }),
  on(addressTreeLoadInitStartAction, (areaObject: GenericStoreApiData, action) => {
    return { ...areaObject, loaded: false };
  }),
  on(addressTreeLoadSuccessAction, (areaObject: GenericStoreApiData, action) => {
    return {
      loaded: true,
      errorGeneric: false,
      errorNotYetImplemented: false,
      isOldDataInUse: false,
      data: action.addressTreeObject,
    };
  }),
  on(addressTreeLoadErrorAction, (areaObject: GenericStoreApiData, action) => {
    return {
      loaded: true,
      errorGeneric: true,
      errorNotYetImplemented: false,
      isOldDataInUse: false,
      data: null,
    };
  })
);
